import ProfilePicture from './ProfilePicture.vue'

export { ProfilePicture }

export default ProfilePicture
